import { useHeroHeader } from '@/hooks/useHeroHeader';
import brandLogo from '@/assets/brand-logo.png';
// 桌面顶导航：深绿通栏对齐官网 Navbar（品牌 + 锚点导航 + 语言 + 在线咨询 + 登录态）
// LangToggle 由此导出，BuyerLayout 移动端 AppBar 复用
import { Box, Typography, Button } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { usePrefs } from '@/store/BuyerPrefsContext';
import { useBuyerAuth } from '@/store/BuyerAuthContext';
import UserMenu from './UserMenu';
import LangSwitcher from './LangSwitcher';

import { tr } from '@/i18n';
/** 语言切换 chip：中/英/韩三选一，币种跟随语言（深绿底/白底通用浅色 chip） */
export function LangToggle() {
  return (
    <LangSwitcher sx={{ bgcolor: 'rgba(255,255,255,0.14)', color: '#D1FAE5', border: '1px solid rgba(255,255,255,0.22)', '&:hover': { bgcolor: 'rgba(255,255,255,0.22)' } }} />
  );
}

export default function BuyerTopNav() {
  const navigate = useNavigate();
  const overPhoto = useHeroHeader();
  const location = useLocation();
  const { t } = usePrefs();
  const { isAuthenticated } = useBuyerAuth();
  const goHash = (hash: string) => {
    if (location.pathname.startsWith('/buyer/home')) {
      document.getElementById(hash)?.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate(`/buyer/home#${hash}`);
    }
  };

  const linkSx = (active: boolean) => ({
    fontSize: '13px',
    color: overPhoto ? '#FFFFFF' : active ? '#064E3B' : '#246454',
    fontWeight: active ? 600 : 400,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    transition: 'color .15s',
    '&:hover': { color: '#00956e' },
  }) as const;

  return (
    <Box
      component="header"
      className={`buyer-desktop-header ${overPhoto ? 'buyer-header--over-photo' : ''}`}
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 40,
        backgroundColor: 'rgba(240,250,244,0.64)',
        backdropFilter: 'blur(8px)',
        WebkitBackdropFilter: 'blur(8px)',
        borderBottom: '1px solid rgba(255,255,255,0.08)',
        transition: 'background-color .25s',
      }}
    >
      <Box sx={{ maxWidth: 1280, mx: 'auto', px: { md: 3 }, height: 60, display: 'flex', alignItems: 'center', gap: { xs: 2, md: 3 } }}>
        {/* 品牌 */}
        <Box onClick={() => navigate('/buyer/home')} sx={{ display: 'flex', alignItems: 'center', gap: 1.25, cursor: 'pointer', flexShrink: 0 }}>
          <Box component="img" src={brandLogo} alt="" sx={{ width: 40, height: 40, objectFit: 'contain' }} />
          <Typography sx={{ fontSize: '15px', fontWeight: 500, color: overPhoto ? '#FFFFFF' : '#064E3B', whiteSpace: 'nowrap' }}>
            Bluplanet
          </Typography>
        </Box>

        {/* 导航链接 */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 2, md: 3 } }}>
          <Typography sx={linkSx(location.pathname.startsWith('/buyer/home'))} onClick={() => navigate('/buyer/home')}>
            {t('nav.home')}
          </Typography>
          <Typography sx={linkSx(false)} onClick={() => goHash('products')}>
            {t('nav.products')}
          </Typography>
          <Typography sx={linkSx(false)} onClick={() => goHash('services')}>
            {t('nav.services')}
          </Typography>
        </Box>

        {/* 右侧动作区 */}
        <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center', gap: { xs: 1.5, md: 2.5 } }}>
          <LangToggle />
          <Typography
            onClick={() => window.dispatchEvent(new CustomEvent('open-lanbao'))}
            sx={{ ...linkSx(false), display: { xs: 'none', lg: 'block' } }}
          >
            {t('nav.ai')}
          </Typography>
          {isAuthenticated ? (
            <UserMenu />
          ) : (
            <>
              <Typography onClick={() => navigate('/buyer/login')} sx={linkSx(false)}>
                {t('nav.login')}
              </Typography>
              <Button
                variant="contained"
                onClick={() => navigate('/buyer/register')}
                sx={{
                  borderRadius: 999, textTransform: 'none', fontWeight: 600,
                  px: 2.5, py: 0.6, fontSize: '13px',
                  bgcolor: '#10B981', '&:hover': { bgcolor: '#059669' },
                }}
              >
                {t('nav.register')}
              </Button>
            </>
          )}
        </Box>
      </Box>
    </Box>
  );
}
